import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useState } from "react";
import { Container } from "./../Container";
import { Paper } from "./../Paper";
import { misc } from "../icons";
import styled from "@emotion/styled";
import { colors } from "../theme";
import { useElementsContext } from "../elementsProvider";
export function RTCExtraInformation({ iconsColor, subelements, typography, }) {
    const { isMobile } = useElementsContext();
    const [currentElement, setCurrentElement] = useState(1);
    const scrolling = useRef(0);
    const filteredSubelements = useMemo(() => subelements.filter(subelement => subelement.hidden === "0"), [subelements]);
    return (_jsx(Container, { children: _jsxs(PaperStyled, Object.assign({ isDesktop: !isMobile }, { children: [_jsx(MobileItemsContainer, Object.assign({ id: "container", onScroll: handleScroll }, { children: filteredSubelements.map((subelement, index) => (_jsxs(InfoItem, Object.assign({ id: `${index + 1}`, isDesktop: !isMobile }, { children: [_jsx(InfoIcon, Object.assign({ iconsColor: iconsColor }, { children: misc[subelement.iconName] }), void 0),
                            _jsxs(TextContainer, { children: [_jsx(InfoTitle, Object.assign({ typography: typography }, { children: subelement.title }), void 0),
                                    _jsx(InfoDescription, Object.assign({ typography: typography }, { children: subelement.description }), void 0)] }, void 0)] }), subelement.identifier))) }), void 0),
                filteredSubelements.length > 1 && (_jsx(PageContainer, Object.assign({ isDesktop: !isMobile }, { children: filteredSubelements.map((subelement, index) => (_jsx(PageIndicator, { selected: currentElement === index + 1 }, subelement.identifier))) }), void 0))] }), void 0) }, void 0));
    function handleScroll(e) {
        clearTimeout(scrolling.current);
        const { scrollWidth, scrollLeft } = e.currentTarget;
        scrolling.current = window.setTimeout(() => updateCurrentElement({ scrollWidth, scrollLeft }), 50 // Minimum duration without breaking the swipe feature
        );
    }
    function updateCurrentElement({ scrollWidth, scrollLeft, }) {
        const elementWidth = scrollWidth / filteredSubelements.length;
        const currentScrollIndex = Math.ceil(scrollLeft / elementWidth);
        const scrollPositionAtCurrentElement = 1 + (scrollLeft - elementWidth * currentScrollIndex) / elementWidth;
        const newScrollIndex = scrollPositionAtCurrentElement > 0.5
            ? currentScrollIndex + 1
            : currentScrollIndex;
        if (newScrollIndex !== currentElement) {
            setCurrentElement(newScrollIndex);
        }
    }
}
const PaperStyled = styled(Paper)(({ isDesktop }) => (Object.assign({ display: "grid", height: "15rem" }, (isDesktop
    ? {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        justifyItems: "center",
        padding: "3.2rem 2.4rem",
        width: "94rem",
    }
    : {}))));
const MobileItemsContainer = styled.div(() => ({
    display: "flex",
    overflow: "auto",
    scrollSnapType: "x mandatory",
    // Hide scrollbars without losing scroll ability
    msOverflowStyle: "none",
    "::-webkit-scrollbar": {
        // Chrome
        display: "none",
    },
}));
const InfoItem = styled.article(({ isDesktop }) => (Object.assign(Object.assign({ alignItems: "center", display: "grid", gridGap: "1.6rem", gridTemplateColumns: "0.6fr 2fr", gridTemplateRows: "9.6rem", justifyContent: "flex-start", padding: "2rem 2rem 1.2rem", minWidth: "100%", scrollSnapAlign: "center" }, (isDesktop
    ? {
        borderRight: "solid 1px hsla(0, 0%, 59%, 1)",
        display: "grid",
        gridGap: "2.4rem",
        gridTemplateColumns: "0.6fr 2fr",
        height: "9.6rem",
        justifyContent: "flex-start",
        minWidth: "24rem",
        padding: "0 1.8rem",
        width: "32rem",
    }
    : {})), { "&:last-of-type": {
        borderRight: "none",
    } })));
const InfoIcon = styled.span(({ iconsColor }) => ({
    fontSize: "4.8rem",
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "column",
    "& svg": {
        color: iconsColor,
    },
}));
const TextContainer = styled.div(() => ({
    display: "block",
}));
const InfoTitle = styled.h2(({ typography }) => ({
    color: colors.black,
    fontFamily: typography,
    fontSize: "1.8rem",
    marginBottom: 2,
}));
const InfoDescription = styled.p(({ typography }) => ({
    color: colors.black,
    fontFamily: typography,
    fontSize: "1.4rem",
    marginTop: 2,
    wordBreak: "break-word",
}));
const PageContainer = styled.div(({ isDesktop }) => (Object.assign({ alignItems: "center", display: "flex", justifyContent: "center", justifyItems: "center", padding: "0 2rem 2rem" }, (isDesktop
    ? {
        display: "none",
    }
    : {}))));
const PageIndicator = styled.button(({ selected }) => ({
    backgroundColor: selected ? colors.greyDark : colors.white,
    borderRadius: "50%",
    cursor: "pointer",
    display: "block",
    padding: "0.4rem 0.4rem",
    width: "0.8rem",
    border: "1px solid",
    borderColor: colors.greyDark,
    margin: "0.8rem",
}));
//# sourceMappingURL=RTCExtraInformation.js.map